import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { selfexclusion } from "../signIn/cl_SignInSlice";
import icons from "../../assets/images/sprite-other-icons.svg";

const SelfExclusion = () => {
  const dispatch = useDispatch();
  const [isActive, setIsActive] = useState(true);
  const [isSelfExclusion, setIsSelfExclusion] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState("");
  const [pin, setPin] = useState("");
  const [showPin, setShowPin] = useState(false);
  const [showPinSection, setShowPinSection] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSelfExclusionChange = (checked) => {
    setIsSelfExclusion(checked);
    setShowPinSection(checked);
    if (checked) {
      setIsActive(false);
    } else {
      setIsActive(true);
      setSelectedPeriod("");
      setPin("");
      setErrorMessage("");
    }
  };

  const handleSubmit = () => {
    setErrorMessage("");
    if (isSelfExclusion && selectedPeriod) {
      setShowConfirmModal(true);
    } else if (isSelfExclusion) {
      if (!selectedPeriod) {
        setErrorMessage("Please select a self-exclusion period");
      }
    }
  };

  const validatePinAndProceed = async () => {
    setIsLoading(true);
    setErrorMessage("");
    try {
      const periodMapping = {
        "2weeks": "TWO_WEEKS",
        "1month": "MONTH", 
        "3months": "THREE_MONTHS",
        "6months": "SIX_MONTHS",
        "permanent": "PERMANENT",
      };
      const selfExclusionPeriod = periodMapping[selectedPeriod];
      if (selfExclusionPeriod) {
        await dispatch(selfexclusion(selfExclusionPeriod));
        setShowSuccessMessage(true);
        setShowConfirmModal(false);
        setTimeout(() => {
          setShowSuccessMessage(false);
          handleReset();
        }, 3000);
      } else {
        setErrorMessage("Invalid period selected");
        setShowConfirmModal(false);
      }
    } catch (error) {
      setErrorMessage("Failed to process self-exclusion. Please try again.");
      setShowConfirmModal(false);
    } finally {
      setIsLoading(false);
    }
  };

  const confirmSubmit = () => {
    validatePinAndProceed();
  };

  const handleReset = () => {
    setIsActive(true);
    setIsSelfExclusion(false);
    setSelectedPeriod("");
    setPin("");
    setShowPinSection(false);
    setShowSuccessMessage(false);
    setErrorMessage("");
  };

  return (
    <div className="SB-page-content">
      <div className="SB-myAccountSection-container SB-responsibleGambling">
        <div className="SB-pageHeader">
          <div className="SB-pageBackButton">
            <div className="SB-iconSVG">
              <svg xmlns="http://www.w3.org/2000/svg">
                <use xlinkHref="images/sprite-other-icons.svg#icon-back"></use>
              </svg>
            </div>
          </div>
          <div className="SB-pageHeader-title">Responsible Gaming</div>
        </div>

        <div className="SB-content">
          <div className="SB-myAccountSection">
            <div className="SB-myAccountSection-header">Self Exclusion</div>

            <div className="SB-myAccountSection-content">
              <div className="SB-row align-items-bottom">
                <div className="SB-col">
                  <div className="SB-form-group">
                    <div className="SB-checkbox">
                      <input
                        id="checkActive"
                        name=""
                        value="check1"
                        checked={isActive}
                        onChange={(e) => setIsActive(e.target.checked)}
                        type="checkbox"
                        disabled={isSelfExclusion}
                      />
                      <label htmlFor="checkActive"></label>
                      <span className="SB-checkboxLabel">Active</span>
                    </div>
                  </div>
                </div>

                <div className="SB-col">
                  <div className="SB-form-group">
                    <div className="SB-checkbox">
                      <input
                        id="checkSelfExclusion"
                        name=""
                        value="check1"
                        checked={isSelfExclusion}
                        onChange={(e) =>
                          handleSelfExclusionChange(e.target.checked)
                        }
                        type="checkbox"
                      />
                      <label htmlFor="checkSelfExclusion"></label>
                      <span className="SB-checkboxLabel">Self Exclusion</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="SB-form-group">
                <div className="SB-select">
                  <select
                    value={selectedPeriod}
                    onChange={(e) => setSelectedPeriod(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="2weeks">2 Weeks</option>
                    <option value="1month">1 Month</option>
                    <option value="3months">3 Months</option>
                    <option value="6months">6 Months</option>
                    <option value="permanent">Permanently (Delete Account)</option>
                  </select>
                </div>
              </div>

              <div
                className="SB-row align-items-bottom"
                id="pinSection"
                style={{ display: showPinSection ? "block" : "none" }}
              ></div>

              {errorMessage && (
                <div
                  className="SB-form-errorMsg"
                  style={{ marginBottom: "10px" }}
                >
                  <span>{errorMessage}</span>
                </div>
              )}

              <div
                className={`SB-msgBox SB-success ${
                  showSuccessMessage ? "" : "d-none"
                }`}
                id="userProfileDetailsSaved"
              >
                <div
                  className="SB-msgBox-container"
                  id="userProfileDetailsError"
                >
                  Self-exclusion has been applied successfully.
                </div>
              </div>

              <div className="SB-btnContainer text-center">
                <button
                  className="btn SB-btn SB-btnSecondary active SB-btnLarge SB-btnReset"
                  onClick={handleReset}
                  disabled={isLoading}
                >
                  Reset
                </button>
                <button
                  className="btn SB-btn SB-btnSecondary active SB-btnLarge"
                  onClick={handleSubmit}
                  disabled={isLoading}
                >
                  {isLoading ? "Processing..." : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </div>

        {showConfirmModal && (
          <div
            className="SB-modal SB-confirm-modal SB-modal-fullscreen show"
            id="confirmModal"
            aria-modal="true"
            role="dialog"
            style={{ display: "block" }}
          >
            <div className="SB-modal-dialog">
              <div className="SB-modal-content">
                <div
                  className="SB-modal-close SB-iconSVG"
                  onClick={() => setShowConfirmModal(false)}
                >
                  <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref={`${icons}#${"icon-close"}`} />
                  </svg>
                </div>
                <div className="SB-modal-header">
                  <div className="SB-modal-title">Are you sure?</div>
                </div>
                <div className="SB-modal-body">
                  <p>
                    The selected self-exclusion will take effect immediately.
                    Are you sure you want to proceed?
                  </p>
                  {errorMessage && (
                    <div
                      className="SB-form-errorMsg"
                      style={{ marginBottom: "10px" }}
                    >
                      <span>{errorMessage}</span>
                    </div>
                  )}
                  <div className="SB-btnContainer">
                    <button
                      className="btn active SB-btnSecondary SB-btnCancelOutline"
                      onClick={() => setShowConfirmModal(false)}
                      disabled={isLoading}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn active SB-btnSecondary SB-confirm"
                      onClick={confirmSubmit}
                      disabled={isLoading}
                    >
                      {isLoading ? "Processing..." : "Yes"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SelfExclusion;